import { Component } from '@angular/core';

/**
 * Payment Settings configuration page: shell around the shared payment
 * methods form (also opened as a dialog from the payment entry form).
 */
@Component({
  selector: 'app-payment-configuration',
  templateUrl: './payment-configuration.component.html',
  styleUrls: ['./payment-configuration.component.css']
})
export class PaymentConfigurationComponent {}
